import DialogTitle from "@mui/material/DialogTitle";
import {Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {Close} from "@mui/icons-material";
import Dialog from "@mui/material/Dialog";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogContentComponent from "../../../common/components/Shared/DialogContentComponent";
import useApi from "../../../api/useApi";
import Rowlog from "../../../common/components/rows/Rowlog";


const AutorizacionLog = ({open, dataFactura, onClose}) => {
    const {t} = useTranslation();
    const [data, setData] = useState([]);
    const api = useApi('configuracion/recepciones/AutorizacionLog');

    useEffect(() => {
        if(open){

            load(dataFactura).then()}
        // eslint-disable-next-line
    }, [open]);

    const load = async (facturaId) => {

        if (facturaId === 0 || facturaId == null) {
            return
        }
        const response = await api.get(facturaId);
        setData(response);
    }

    const cerrar = () => {
        onClose();
    }

    return(
        <>
            <Dialog
                open={open}
                fullWidth={true}
                maxWidth={'md'}>
                <DialogTitle fontWeight={'bold'}>
                    <Box sx={{display: "grid", gridAutoColumns: "1fr", width: "100%", gap: "10px"}}>
                        <Box sx={{gridRow: "1", gridColumn: "1/7"}}>
                            { t(`Log Autorización`)}
                        </Box>
                    </Box>

                    <IconButton sx={{position: 'absolute', right: 8, top: 8}} onClick={() => cerrar()}>
                        <Close/>
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{marginInline: 4}}>
                    <DialogContentComponent>
                        <TableContainer sx={{height:200 }}>
                            <Table aria-label="sticky collapsible table" stickyHeader size={'small'}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" sx={{fontWeight:'bold', width: 100}}>{t('Fecha')}</TableCell>
                                        <TableCell align="left" sx={{fontWeight:'bold', width: 150}}>{t('Estatus')}</TableCell>
                                        <TableCell align="left" sx={{fontWeight:'bold', width: 300}}>{t('Mensaje')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.map((row, index) => (
                                        <Rowlog key={index} props={row}/>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContentComponent>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default AutorizacionLog;
